<div #medEditElRef [innerHTML]="innerHTMLText" class="web-link-text"></div>
